import React from 'react';
import { Button, Flex, Text } from 'pounceV2';

const NetworkErrorModalV3: React.FC = () => {
  return (
    <React.Fragment>
      <Text mb={10} textAlign="center">
        Somebody is watching cat videos and is preventing you from being online
        <br />
        That&apos;s the most likely scenario anyway...
      </Text>
      <Flex justify="center">
        <Button variant="destructive" loading disabled>
          Reconnecting
        </Button>
      </Flex>
    </React.Fragment>
  );
};

export default NetworkErrorModalV3;
